import React from 'react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card border border-brand-border rounded-lg p-4" data-id="element-166">
    <p className="text-yellow text-sm mb-2" data-id="element-167">★★★★★</p>
    <p className="text-sm font-bold text-white mb-2" data-id="element-168">
      {name} <span className="text-brand-muted font-normal" data-id="element-169">– {location}</span>
    </p>
    <p className="text-sm text-brand-text italic leading-relaxed" data-id="element-170">"{text}"</p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Rodrigo M.',
    location: 'Argentina',
    text: 'Siempre veía videos en YouTube pero terminaba más confundido que antes. Con este material entendí los comandos eléctricos paso a paso y pude empezar a hacer mis primeras instalaciones con confianza.'
  }, {
    name: 'Carlos V.',
    location: 'Colombia',
    text: 'Compré el pack por la parte de PLC y automatización. Está explicado de forma simple y práctica. Hoy ya entiendo conceptos que antes me parecían imposibles.'
  }, {
    name: 'Fernando R.',
    location: 'Chile',
    text: 'Lo que más me gustó fueron los diagramas y planos. Tener todo organizado en un solo lugar me ahorró muchísimo tiempo y me ayudó a resolver trabajos reales.'
  }, {
    name: 'Miguel A.',
    location: 'México',
    text: 'Arranqué sin experiencia y el contenido me sorprendió. Las explicaciones son claras y podés aplicar lo aprendido desde el primer día. Muy recomendable.'
  }, {
    name: 'Sebastián L.',
    location: 'Uruguay',
    text: 'Buscaba aprender electricidad para hacer arreglos en casa y terminé haciendo trabajos para conocidos. El material es práctico, directo y fácil de seguir.'
  }];
  return <section className="bg-brand-surface text-brand-text px-4 py-10" data-id="element-171">
      <div className="max-w-xl mx-auto" data-id="element-172">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-yellow" data-id="element-173">
          TESTIMONIOS DE NUESTROS ELECTRICISTAS
        </h2>
        <div className="space-y-3" data-id="element-174">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-175" />)}
        </div>
      </div>
    </section>;
}